import React from "react";
import styles from "./ProductCard.module.css";



const ProductCard = ({ title, image, weight, description }) => (
  <div className={styles.card}>
    <div className={styles.cardInner}>
      <div className={styles.cardFront}>
        <img src={image} alt={title} className={styles.fullImage} />
      </div>
      <div className={styles.cardBack}>
        <h4>{title}</h4>
        <p className={styles.details}>{weight}</p>
        <p>{description}</p>
      </div>
    </div>
  </div>
);

export default ProductCard;
